import React from "react";
import { Home, Store } from "lucide-react";

interface NavigationButtonsProps {
  lojasCount: number;
  onGoHome?: () => void;
  onToggleLojaSelector?: () => void;
}

export const NavigationButtons: React.FC<NavigationButtonsProps> = ({
  lojasCount,
  onGoHome,
  onToggleLojaSelector,
}) => {
  return (
    <div className="fixed left-2 top-2 z-40 flex gap-2 sm:left-4 sm:top-4">
      <button
        type="button"
        onClick={onGoHome}
        className="rounded-full bg-black/20 p-2 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100"
        title="Voltar ao início"
      >
        <Home size={20} className="text-white" />
      </button>
      {lojasCount > 0 && (
        <button
          type="button"
          onClick={onToggleLojaSelector}
          className="rounded-full bg-black/20 p-2 opacity-50 backdrop-blur-sm transition-all duration-200 hover:bg-black/40 hover:opacity-100"
          title="Selecionar loja"
        >
          <Store size={20} className="text-white" />
        </button>
      )}
    </div>
  );
};
